/* KVIKA FOOD — sliders, counters, video tiles, track order, farm timeline and cart extras.
   No libraries. Safe to include more than once. */
(function () {
  if (window.__kvikaPlus) return;
  window.__kvikaPlus = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(c) { return window.KvikaCart && KvikaCart.formatMoney ? KvikaCart.formatMoney(c) : '₹' + (c / 100).toFixed(2); }

  /* ---------------- Slider: [data-kv-slider] (native scroll + snap) ---------------- */
  function sliderButtons(track) {
    var id = track.id;
    if (!id) return { prev: [], next: [] };
    return {
      prev: $$('[data-kv-slider-prev][aria-controls="' + id + '"]'),
      next: $$('[data-kv-slider-next][aria-controls="' + id + '"]')
    };
  }
  function stride(track) {
    var items = track.children;
    if (items.length < 2) return items[0] ? items[0].getBoundingClientRect().width : track.clientWidth;
    return items[1].getBoundingClientRect().left - items[0].getBoundingClientRect().left;
  }
  function pageStep(track) {
    var s = Math.abs(stride(track)) || track.clientWidth;
    return s * Math.max(1, Math.floor((track.clientWidth + 8) / s));
  }
  function atStart(track) { return track.scrollLeft <= 4; }
  function atEnd(track) { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
  function updateSlider(track) {
    var b = sliderButtons(track);
    var static_ = track.scrollWidth <= track.clientWidth + 4;
    b.prev.forEach(function (btn) { btn.disabled = static_ || atStart(track); });
    b.next.forEach(function (btn) { btn.disabled = static_ || atEnd(track); });
    var nav = b.prev[0] && b.prev[0].closest('.kvsl-nav');
    if (nav) nav.classList.toggle('is-static', static_);
    track.classList.toggle('is-static', static_);
  }
  function go(track, dir) {
    var behavior = reduce ? 'auto' : 'smooth';
    if (dir > 0 && atEnd(track)) track.scrollTo({ left: 0, behavior: behavior });
    else track.scrollBy({ left: dir * pageStep(track), behavior: behavior });
  }
  function initSlider(track) {
    if (track.__kvSlider) return;
    track.__kvSlider = true;
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () { raf = null; updateSlider(track); });
    }, { passive: true });
    window.addEventListener('resize', function () { updateSlider(track); }, { passive: true });
    updateSlider(track);
    setTimeout(function () { updateSlider(track); }, 600);

    var auto = track.getAttribute('data-autoplay');
    if (auto === null || auto === 'false' || reduce) return;
    var delay = parseInt(track.getAttribute('data-interval'), 10) || 4200;
    var paused = false, visible = false, timer = null;
    function tick() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (!paused && visible && !document.hidden && track.scrollWidth > track.clientWidth + 4) go(track, 1);
        tick();
      }, delay);
    }
    ['mouseenter', 'focusin', 'pointerdown', 'touchstart'].forEach(function (ev) {
      track.addEventListener(ev, function () { paused = true; }, { passive: true });
    });
    track.addEventListener('mouseleave', function () { paused = false; });
    track.addEventListener('focusout', function (e) { if (!track.contains(e.relatedTarget)) paused = false; });
    track.addEventListener('touchend', function () { setTimeout(function () { paused = false; }, 5000); }, { passive: true });
    if (hasIO) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.3 }).observe(track);
    else visible = true;
    tick();
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kv-slider-prev], [data-kv-slider-next]');
    if (!btn) return;
    var track = document.getElementById(btn.getAttribute('aria-controls'));
    if (!track) return;
    go(track, btn.hasAttribute('data-kv-slider-next') ? 1 : -1);
  });

  /* ---------------- Count-up numbers: [data-kv-count] ---------------- */
  function fmtNum(n) { try { return Math.round(n).toLocaleString('en-IN'); } catch (e) { return String(Math.round(n)); } }
  function initCount(el) {
    if (el.__kvCount) return;
    el.__kvCount = true;
    var target = parseFloat(el.getAttribute('data-kv-count'));
    if (isNaN(target)) return;
    el.textContent = fmtNum(target);
    if (reduce || !hasIO) return;
    el.textContent = '0';
    var io = new IntersectionObserver(function (en) {
      if (!en[0].isIntersecting) return;
      io.disconnect();
      var start = null, dur = Math.min(2200, 900 + target * 4);
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        el.textContent = fmtNum(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, { threshold: 0.01, rootMargin: '0px 0px -12% 0px' });
    io.observe(el.parentNode || el);
  }

  /* ---------------- Video tiles: [data-kv-reel] ---------------- */
  function initReel(tile) {
    if (tile.__kvReel) return;
    tile.__kvReel = true;
    var v = tile.querySelector('video');
    if (!v) return;
    v.muted = true; v.loop = true; v.setAttribute('playsinline', ''); v.removeAttribute('controls');
    var userPaused = reduce, onScreen = false;
    function sync() {
      if (onScreen && !userPaused && !document.hidden) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
      tile.classList.toggle('is-playing', onScreen && !userPaused);
    }
    if (hasIO) new IntersectionObserver(function (en) { onScreen = en[0].intersectionRatio >= 0.55; sync(); }, { threshold: [0, 0.55, 1] }).observe(tile);
    document.addEventListener('visibilitychange', sync);
    var frame = tile.querySelector('.kvreel__frame');
    if (frame) frame.addEventListener('click', function (e) {
      if (e.target.closest('[data-kv-reel-sound]')) return;
      userPaused = !userPaused; sync();
    });
    var snd = tile.querySelector('[data-kv-reel-sound]');
    if (snd) snd.addEventListener('click', function () {
      var on = v.muted;
      $$('[data-kv-reel] video').forEach(function (o) { if (o !== v) { o.muted = true; var b = o.closest('[data-kv-reel]').querySelector('[data-kv-reel-sound]'); if (b) b.setAttribute('aria-pressed', 'false'); } });
      v.muted = !on;
      snd.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (on) { userPaused = false; sync(); }
    });
    sync();
  }

  /* ---------------- Track order: [data-kv-track] ---------------- */
  var yqState = 0, yqWait = [];
  function load17(cb) {
    if (window.YQV5) return cb(true);
    yqWait.push(cb);
    if (yqState) return;
    yqState = 1;
    var s = document.createElement('script');
    var done = function (ok) { var w = yqWait; yqWait = []; yqState = 0; w.forEach(function (f) { f(ok); }); };
    var timer = setTimeout(function () { done(!!window.YQV5); }, 8000);
    s.src = 'https://www.17track.net/externalcall.js';
    s.async = true;
    s.onload = function () { clearTimeout(timer); done(!!window.YQV5); };
    s.onerror = function () { clearTimeout(timer); done(false); };
    document.head.appendChild(s);
  }
  function initTrack(form) {
    if (form.__kvTrack) return;
    form.__kvTrack = true;
    var input = form.querySelector('[data-kv-track-number]');
    var sel = form.querySelector('[data-kv-track-courier]');
    var err = form.querySelector('[data-kv-track-error]');
    try { var last = localStorage.getItem('kvika-awb'); if (last && input && !input.value) input.value = last; } catch (e) {}
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var n = (input.value || '').replace(/\s+/g, '').trim();
      var ok = /^[A-Za-z0-9-]{5,40}$/.test(n);
      if (err) err.hidden = ok;
      input.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (!ok) { input.focus(); return; }
      try { localStorage.setItem('kvika-awb', n); } catch (e2) {}
      var tpl = sel && sel.value ? sel.value : 'https://t.17track.net/en#nums={number}';
      var url = tpl.indexOf('{number}') > -1 ? tpl.split('{number}').join(encodeURIComponent(n)) : tpl + encodeURIComponent(n);
      var inline = form.getAttribute('data-inline') === 'true' && /17track/.test(tpl);
      var card = form.closest('.kvtrack__card') || document;
      var box = card.querySelector('[data-kv-track-result]');
      var frame = card.querySelector('[data-kv-track-frame]');
      var openLink = card.querySelector('[data-kv-track-open]');
      var label = card.querySelector('[data-kv-track-label]');
      function openTab() {
        var w = window.open(url, '_blank');
        if (w) { try { w.opener = null; } catch (e3) {} } else { window.location.href = url; }
      }
      if (!inline || !box || !frame) { openTab(); return; }
      box.hidden = false;
      if (openLink) openLink.href = url;
      if (label) label.textContent = 'Tracking ' + n;
      frame.innerHTML = '<p class="kvtrack__loading">Fetching the latest updates…</p>';
      load17(function (okLoad) {
        if (!okLoad || !window.YQV5) { frame.innerHTML = ''; box.hidden = true; openTab(); return; }
        frame.innerHTML = '';
        try {
          window.YQV5.trackSingle({ YQ_ContainerId: frame.id, YQ_Height: 560, YQ_Fc: '0', YQ_Lang: 'en', YQ_Num: n });
          box.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        } catch (e4) { box.hidden = true; openTab(); }
      });
    });
    if (input) input.addEventListener('input', function () { if (err && !err.hidden) { err.hidden = true; input.setAttribute('aria-invalid', 'false'); } });
  }

  /* ---------------- Farm timeline progress: [data-kv-farm] ---------------- */
  var farms = [], farmTick = false;
  function farmUpdate() {
    farmTick = false;
    var vh = window.innerHeight;
    farms.forEach(function (sec) {
      var track = sec.querySelector('.kvfarm__track');
      if (!track) return;
      var r = track.getBoundingClientRect();
      var p = (vh * 0.78 - r.top) / (r.height || 1);
      track.style.setProperty('--kv-farm-p', Math.max(0, Math.min(1, p)).toFixed(3));
      $$('.kvfarm__step', track).forEach(function (st) {
        var sr = (st.querySelector('.kvjr__node, .kvjr__end') || st).getBoundingClientRect();
        st.classList.toggle('is-lit', sr.top < vh * 0.8);
      });
    });
  }
  function initFarm(sec) {
    if (sec.__kvFarm) return;
    sec.__kvFarm = true;
    farms.push(sec);
    if (reduce) { var t = sec.querySelector('.kvfarm__track'); if (t) t.style.setProperty('--kv-farm-p', 1); $$('.kvfarm__step', sec).forEach(function (s) { s.classList.add('is-lit'); }); return; }
    farmUpdate();
  }
  window.addEventListener('scroll', function () { if (farms.length && !farmTick) { farmTick = true; requestAnimationFrame(farmUpdate); } }, { passive: true });

  /* ---------------- Product recommendations: [data-kv-recs] ---------------- */
  var recCache = {};
  function fetchRecs(pid) {
    if (!recCache[pid]) {
      recCache[pid] = fetch(ROOT + 'recommendations/products.json?product_id=' + encodeURIComponent(pid) + '&limit=8&intent=related', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d && d.products) || []; })
        .catch(function () { return []; });
    }
    return recCache[pid];
  }
  function imgUrl(src, w) {
    if (!src) return '';
    if (typeof src === 'object') src = src.src || src.url || '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function buildRec(p, style) {
    var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
    if (!v) return null;
    var li = document.createElement('li');
    li.className = 'kvup' + (style === 'card' ? ' kvup--card' : '');
    li.setAttribute('data-kv-upsell-item', String(p.id));
    li.setAttribute('data-rec', '');
    var price = v.price != null ? v.price : p.price;
    var was = v.compare_at_price != null ? v.compare_at_price : p.compare_at_price;
    var img = imgUrl(p.featured_image, 300);
    li.innerHTML =
      '<a href="' + esc(p.url) + '" class="kvup__img" tabindex="-1" aria-hidden="true">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="300" height="300">' : '') + '</a>' +
      '<div class="kvup__info"><a class="kvup__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
      '<span class="kvup__price">' + esc(money(price)) + (was && was > price ? ' <s>' + esc(money(was)) + '</s>' : '') + '</span></div>' +
      '<form method="post" action="' + ROOT + 'cart/add" class="kvup__form" data-kv-atc>' +
      '<input type="hidden" name="id" value="' + esc(v.id) + '"><input type="hidden" name="quantity" value="1">' +
      '<button type="submit" class="kvup__add" aria-label="Add ' + esc(p.title) + ' to cart">' +
      '<svg class="kv-ico kv-ico--sm" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.8" stroke-linecap="round"/></svg><span>Add</span></button></form>';
    return li;
  }
  function fillRecs(box, cartIds) {
    var list = box.querySelector('[data-kv-recs-list]');
    if (!list) return;
    var limit = parseInt(box.getAttribute('data-limit'), 10) || 4;
    var style = box.getAttribute('data-style') || 'row';
    var exclude = {};
    cartIds.forEach(function (id) { exclude[id] = true; });
    var token = (box.__kvRecToken || 0) + 1;
    box.__kvRecToken = token;
    function apply(recs) {
      if (box.__kvRecToken !== token) return;
      $$('[data-rec]', list).forEach(function (li) { li.remove(); });
      var seen = {}, frag = document.createDocumentFragment(), added = 0;
      recs.forEach(function (p) {
        var id = String(p.id);
        if (added >= limit || exclude[id] || seen[id] || p.available === false) return;
        var li = buildRec(p, style);
        if (!li) return;
        seen[id] = true; frag.appendChild(li); added++;
      });
      list.insertBefore(frag, list.firstChild);
      var shown = 0;
      $$('[data-kv-upsell-item]', list).forEach(function (li) {
        var id = li.getAttribute('data-kv-upsell-item');
        var isRec = li.hasAttribute('data-rec');
        var hide = exclude[id] || (!isRec && seen[id]) || shown >= limit;
        li.hidden = !!hide;
        if (!li.hidden) { shown++; if (!isRec) seen[id] = true; }
      });
      box.hidden = shown === 0;
      list.dispatchEvent(new Event('scroll'));
    }
    apply([]);
    var sources = cartIds.slice(0, 3);
    if (!sources.length || !window.fetch) return;
    Promise.all(sources.map(fetchRecs)).then(function (lists) {
      var merged = [];
      var max = Math.max.apply(null, lists.map(function (l) { return l.length; }));
      for (var i = 0; i < max; i++) lists.forEach(function (l) { if (l[i]) merged.push(l[i]); });
      apply(merged);
    });
  }
  function initRecs(box) {
    if (box.__kvRecs || box.closest('[data-kv-drawer]')) return;
    box.__kvRecs = true;
    var ids = (box.getAttribute('data-product-ids') || '').split(',').filter(Boolean);
    fillRecs(box, ids);
  }
  // On the cart page, reload after a quick add so the new line and totals show
  document.addEventListener('kvika:cart-added', function () {
    if (document.querySelector('[data-kv-cartpage]')) setTimeout(function () { window.location.reload(); }, 250);
  });

  /* ---------------- Sticky helper: a parent with overflow:hidden stops position:sticky working ---------------- */
  function initSticky(el) {
    if (el.__kvSticky) return;
    el.__kvSticky = true;
    for (var a = el.parentElement; a && a !== document.documentElement; a = a.parentElement) {
      var cs = getComputedStyle(a);
      if (cs.overflowX === 'hidden' || cs.overflowY === 'hidden') {
        if (cs.overflowX === 'hidden') a.style.overflowX = 'clip';
        if (cs.overflowY === 'hidden') a.style.overflowY = 'clip';
      }
    }
  }

  /* ---------------- Cart drawer extras ---------------- */
  var lastCart = null;
  function cartPost(url, data) {
    return fetch(ROOT + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(data) })
      .then(function (r) { return r.json(); });
  }
  function rerender(cart) {
    if (cart && cart.items && window.KVIKA && KVIKA.renderCart) KVIKA.renderCart(cart);
    else if (window.KvikaCart) KvikaCart.refresh();
  }
  function appliedCodes(cart) {
    return (cart && cart.discount_codes ? cart.discount_codes : []).filter(function (d) { return d && d.code; });
  }
  function drawCodes(d, cart) {
    var list = d.querySelector('[data-kv-coupon-codes]');
    if (!list) return;
    var codes = appliedCodes(cart);
    list.innerHTML = codes.map(function (c) {
      return '<li class="' + (c.applicable ? 'is-ok' : 'is-bad') + '"><span>' + esc(c.code) + (c.applicable ? '' : ' · not applicable yet') + '</span>' +
        '<button type="button" data-kv-coupon-rm="' + esc(c.code) + '" aria-label="Remove code ' + esc(c.code) + '">×</button></li>';
    }).join('');
    if (codes.length) { var det = d.querySelector('[data-kv-coupon]'); if (det) det.open = true; }
  }
  document.addEventListener('kvika:cart-rendered', function (e) {
    var cart = e.detail;
    lastCart = cart;
    var d = document.querySelector('[data-kv-drawer]');
    if (!d || !cart) return;
    var ex = d.querySelector('[data-kv-cart-extras]');
    if (ex) ex.hidden = !cart.item_count;
    // Recommendations: Shopify's picks for the cart items, then the backup list
    var up = d.querySelector('[data-kv-recs]');
    if (up) {
      var h = up.querySelector('.kvcart__upsell-h');
      if (h) {
        if (!h.getAttribute('data-label')) h.setAttribute('data-label', h.textContent);
        h.textContent = cart.item_count ? h.getAttribute('data-label') : 'Popular picks';
      }
      fillRecs(up, (cart.items || []).map(function (it) { return String(it.product_id); }));
    }
    // Savings row
    var save = d.querySelector('[data-kv-cart-save]');
    if (save) {
      var amt = (cart.original_total_price || 0) - (cart.total_price || 0);
      save.hidden = !(amt > 0 && cart.item_count);
      var a = save.querySelector('[data-kv-cart-save-amt]');
      if (a) a.textContent = money(amt);
    }
    drawCodes(d, cart);
  });

  function applyCodes(d, codes, msgOk) {
    var msg = d.querySelector('[data-kv-coupon-msg]');
    var btn = d.querySelector('[data-kv-coupon-form] [type="submit"]');
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    return cartPost('cart/update.js', { discount: codes.join(',') })
      .then(function (cart) {
        if (!cart || !cart.items) throw new Error((cart && (cart.description || cart.message)) || 'Could not apply the code.');
        rerender(cart);
        if (!('discount_codes' in cart)) {
          // Older cart API: save the code for checkout instead
          var last = codes[codes.length - 1];
          if (last) fetch(ROOT + 'discount/' + encodeURIComponent(last), { credentials: 'same-origin' }).catch(function () {});
          if (msg) msg.textContent = last ? 'Code saved — it will be applied at checkout.' : '';
          return;
        }
        if (!msg) return;
        var added = codes[codes.length - 1];
        var hit = appliedCodes(cart).filter(function (c) { return c.code.toLowerCase() === String(added || '').toLowerCase(); })[0];
        if (!msgOk) msg.textContent = '';
        else if (hit && hit.applicable) msg.textContent = 'Code applied! Your savings show below.';
        else msg.textContent = 'This code isn’t valid for your cart yet. Check the conditions and try again.';
      })
      .catch(function (err) { if (msg) msg.textContent = err.message || 'Something went wrong. Please try again.'; })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-kv-coupon-form]');
    if (!form) return;
    e.preventDefault();
    var d = form.closest('[data-kv-drawer]');
    var input = form.querySelector('[data-kv-coupon-input]');
    var code = (input.value || '').trim();
    if (!code) { input.focus(); return; }
    var codes = appliedCodes(lastCart).map(function (c) { return c.code; }).filter(function (c) { return c.toLowerCase() !== code.toLowerCase(); });
    codes.push(code);
    applyCodes(d, codes, true).then(function () { input.value = ''; });
  });
  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('[data-kv-coupon-rm]');
    if (!rm) return;
    var d = rm.closest('[data-kv-drawer]');
    var code = rm.getAttribute('data-kv-coupon-rm');
    var codes = appliedCodes(lastCart).map(function (c) { return c.code; }).filter(function (c) { return c !== code; });
    applyCodes(d, codes, false);
  });
  var noteTimer = null;
  document.addEventListener('input', function (e) {
    if (!e.target.matches || !e.target.matches('[data-kv-note-input]')) return;
    var val = e.target.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { cartPost('cart/update.js', { note: val }).catch(function () {}); }, 600);
  });

  /* ---------------- Boot ---------------- */
  function initAll(scope) {
    $$('[data-kv-slider]', scope).forEach(initSlider);
    $$('[data-kv-count]', scope).forEach(initCount);
    $$('[data-kv-reel]', scope).forEach(initReel);
    $$('[data-kv-track]', scope).forEach(initTrack);
    $$('[data-kv-farm]', scope).forEach(initFarm);
    $$('[data-kv-recs]', scope).forEach(initRecs);
    $$('[data-kv-sticky]', scope).forEach(initSticky);
  }
  function boot() { initAll(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    farms = farms.filter(function (f) { return !e.target.contains(f); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var track = e.target.closest && e.target.closest('[data-kv-slider]');
    if (track) track.scrollTo({ left: track.scrollLeft + e.target.getBoundingClientRect().left - track.getBoundingClientRect().left, behavior: 'smooth' });
  });
})();
